import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { setResponseMessage } from "../adminSlice";
import { PromoAdminState } from "./types";

const initialState: PromoAdminState = {
  promotions: [],
  promotion: undefined,
  loading: false,
  options: undefined,
};

const promoAdmin = createSlice({
  name: "promoAdminSlice",
  initialState,
  reducers: {
    setPromos(state, action) {
      state.promotions = action.payload;
    },
    setPromoOptions(state, action) {
      state.options = action.payload;
    },
    setPromo(state, action) {
      state.promotion = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});
export const {
  setLoading,
  setPromos,
  setPromo,
  setPromoOptions,
} = promoAdmin.actions;
export const selectLoading = (state: RootState) => state.promoAdmin.loading;
export const selectPromo = (state: RootState) => state.promoAdmin.promotion;

export const selectAllPromos = (state: RootState) =>
  state.promoAdmin.promotions;
export const selectPromoOptions = (state: RootState) =>
  state.promoAdmin.options;
export const fetchAllPromos = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/admin/promotions`);
    batch(() => {
      dispatch(setPromos(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const fetchPromoOptions = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/admin/promotion-options`);
    batch(() => {
      dispatch(setPromoOptions(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchPromoOptions: ${error.message}`);
  }
};
export const fetchPromo = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/admin/promotion-values/${id}`);
    batch(() => {
      dispatch(setPromo(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const addPromo = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);

    let token = userStorage.getUser();
    const response = await axios.post(
      `${API_URL}/admin/promotions`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    dispatch(
      setResponseMessage({
        message: "Успешно създадохте промоцията.",
        hasError: false,
      })
    );
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const updatePromo = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);

    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/admin/promotions/${data.id}`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    dispatch(
      setResponseMessage({
        message: "Успешно променихте промоцията.",
        hasError: false,
      })
    );
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const deletePromo = (id: string) => async (dispatch: any) => {
  try {
    let token = userStorage.getUser();
    const response = await axios.delete(`${API_URL}/admin/promotions/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно изтрихте промоцията.",
          hasError: false,
        })
      );
      dispatch(fetchAllPromos());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export default promoAdmin.reducer;
